import Swiper, { Navigation, Pagination } from 'swiper'

Swiper.use([Navigation, Pagination])

new Swiper('.js-techHeroSlider .swiper-container', {
  navigation: {
    nextEl: '.js-techHeroSliderNext',
    prevEl: '.js-techHeroSliderPrev',
  },
  pagination: {
    el: '.js-techHeroSlider .swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
  breakpoints: {
    320: {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 20,
    },
    768: {
      loop: true,
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1150: {
      loop: false,
      spaceBetween: 25,
      slidesPerView: 3,
    },
  },
})
